// extracted by mini-css-extract-plugin
export default {"content":"Overquotainfo__content--4Izcx","title":"Overquotainfo__title--1Mas6","secondaryButton":"Overquotainfo__secondaryButton--1WZ1c"};